import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import { Accordion, Card, Button, ProgressBar, Table } from 'react-bootstrap';
import TransactionStatus from './TransactionStatus'
import { Web3StatusContext } from "../contexts/Web3StatusContext";
import { Trans } from 'react-i18next';
import DateComponent from "./DateComponent";

const { AccountData, ContractData, ContractForm } = newContextComponents;

class WhitelistForm extends React.Component {
  static contextType = Web3StatusContext;

  state = {
    whitelistRegEndTimeDataKey: null,
    isWhitelistedDataKey: null,
    inputAddress: null,
    activeAccount: null,
    inputAmount: 0,
    stackId: -1,
  };

  componentDidMount() {
    const { drizzle } = this.props;
    const contract = drizzle.contracts.GAMEFORESTSale;

    const whitelistRegEndTimeDataKey = contract.methods["getTime"].cacheCall(0);
    
    this.setState({ whitelistRegEndTimeDataKey });

    if(this.context.activeAccount == null)
      return;
    
    const isWhitelistedDataKey = contract.methods["isWhitelisted"].cacheCall(this.context.activeAccount);
    this.setState({isWhitelistedDataKey: isWhitelistedDataKey, activeAccount: this.context.activeAccount});
  }

  mySubmitHandler = (event) => {
    event.preventDefault();
    if(this.context.activeAccount == null)
      return;
    const { drizzle } = this.props;
    const contract = drizzle.contracts.GAMEFORESTSale;
    var wei = this.context.web3.utils.toWei(
      this.state.inputAmount.toString(), "ether");
    const stackId = contract.methods.addWhitelisted.cacheSend
                      (this.context.activeAccount, wei);
    this.setState({stackId: stackId});
  }

  myChangeHandler = (event) => {
    var inputAddress = event.target.value;
    this.setState({inputAddress: inputAddress});
  }
  
  isNumber(n) {
    return !isNaN(n) && isFinite(n);
  }

  myAmountChangeHandler = (event) => {
    var inputAmount = event.target.value;

    inputAmount = parseFloat(inputAmount);

    if (!this.isNumber(inputAmount)) {
      inputAmount = this.state.inputAmount;
    }
    this.setState({inputAmount: inputAmount});
  }

  // destructure drizzle and drizzleState from props
  render() {
    const { activeAccount } = this.context;

    // destructure drizzle and drizzleState from props
    if(activeAccount == null) {//remove this
      return (
        <div><Trans>whitelist_form.connect_wallet</Trans><br/>
          <button onClick={this.context.connect}>
          <Trans>connect_account</Trans>
          </button>
        </div>
      );
    }
    
    //add connect wallet
    var statusMsg = '';
    if (this.state.stackId >= 0) {
      statusMsg = (
        <TransactionStatus
          drizzle={this.props.drizzle}
          drizzleState={this.props.drizzleState}
          stackId={this.state.stackId}
        >

        </TransactionStatus>
      );
    }


    // get the contract state from drizzleState
    const { GAMEFORESTSale } = this.props.drizzleState.contracts;

    var whitelistRegEndTimeContract = GAMEFORESTSale["getTime"][this.state.whitelistRegEndTimeDataKey];
    var isWhitelistedContract = GAMEFORESTSale["isWhitelisted"][this.state.isWhitelistedDataKey];
    
    if(whitelistRegEndTimeContract == undefined ||
      (isWhitelistedContract == undefined && this.context.activeAccount != null)) {
      return <div><Trans>loading</Trans></div>;
    }

    var whitelistRegEndTime = parseInt(whitelistRegEndTimeContract.value);
    const nowUnix = Math.floor(Date.now() / 1000);
    var whiteListRegConcluded = nowUnix >= whitelistRegEndTime;
    
    var form = <span><Trans>whitelist_form.reg_concluded</Trans></span>;

    var buttonCaption = this.context.i18n.t('whitelist_form.button_caption');

    if(isWhitelistedContract.value)
      form = <span><Trans>whitelist_form.already_whitelisted</Trans></span>;
    else if(!whiteListRegConcluded) {
      form = (
        <form onSubmit={this.mySubmitHandler}>
          {statusMsg}<br/>
          <Trans>whitelist_form.add_whitelist</Trans><br/>
          <Trans>whitelist_form.whitelist_ends_at</Trans>
          <br/>
          <DateComponent drizzle={this.props.drizzle}
            drizzleState={this.props.drizzleState}
            dateName="getTime"
            getterParameter={0}>
          </DateComponent>
          <Trans>whitelist_form.amount</Trans><br/>
          <input
            type='number'
            step={0.00000001}
            onChange={this.myAmountChangeHandler}
          />BNB
          <br/>
          <input
            type='submit'
            value={buttonCaption}
          />
        </form>
      );
    }

    return (
      <div>
        {form}
      </div>
      
    );
  }
};

export default WhitelistForm;
